module.exports = new __parcel__URL__("jira-board-window.ed7746df.svg").toString();